export default "__VITE_ASSET__09f21d61__"